/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusKundeProjektleiterDto } from '../../models/lexplus-kunde-projektleiter-dto';

export interface KundeProjektleiterControllerGetProjektleiterV1$Params {
}

export function kundeProjektleiterControllerGetProjektleiterV1(http: HttpClient, rootUrl: string, params?: KundeProjektleiterControllerGetProjektleiterV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusKundeProjektleiterDto>> {
  const rb = new RequestBuilder(rootUrl, kundeProjektleiterControllerGetProjektleiterV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusKundeProjektleiterDto>;
    })
  );
}

kundeProjektleiterControllerGetProjektleiterV1.PATH = '/v1/kunden/projektleiter';
